import { render, staticRenderFns } from "./info3.vue?vue&type=template&id=036f62e9&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "info3.vue"
export default component.exports